import React, {useEffect, useState, useRef} from 'react';
import './style.scss';
import config from './config.json';
import media from '../../media';
import Layout from "../../components/layout/main";
import Banner from "../../components/banner/main";
import BodyText from "../../components/body-text/main";
import BenefitBoxes from "../../components/benefit-boxes/main";
import Slider from "../../components/slider/main";
import Accordion from "../../components/accordion/main";
import YoutubeVideo from "../../components/youtube-video/main";


export default function Home(props) {
    return (
        <div className="home">
            <Layout>
                <div className="banner1">
                    <Banner content={config.banner1} />
                </div>

                <div className="intro-block">
                    <div className="inner-content">
                        <BodyText content={config.intro} />
                    </div>
                </div>

                <div className="benefits-block">
                    <div className="inner-content">
                        <BodyText content={config.benefits} />

                        <BenefitBoxes content={config.benefits.boxes} />
                    </div>
                </div>

                <div className="what-block">
                    <div className="inner-content">
                        <BodyText content={config.what} />

                        <Slider id={config.what.slider.id} totalViews={1} dots={true} navbtns={true} onComplete={null}>
                            {config.what.slider.slides.map((slide, key) => {
                                return (
                                    <div className="slide-content" key={key}>
                                        <p dangerouslySetInnerHTML={{__html:slide}}></p>
                                    </div>
                                )
                            })}
                        </Slider>
                    </div>
                </div>

                <div className="banner2">
                    <Banner content={config.banner2} />
                </div>

                <div className="why-block">
                    <div className="inner-content">
                        <BodyText content={config.why} />

                        <Accordion bars={config.why.bars} type="multiple">
                            {config.why.perspectives.map((perspective, i) => {
                                return (
                                    <div className="perspective" key={i}>
                                        <ul className="list">
                                            {perspective.list.map((bullet, j) => {
                                                return (
                                                    <li className="bullet" key={j} dangerouslySetInnerHTML={{__html:bullet}}></li>
                                                )
                                            })}
                                        </ul>

                                        {perspective.extra && <p className="extra" dangerouslySetInnerHTML={{__html:perspective.extra}}></p>}
                                    </div>
                                )
                            })}
                        </Accordion>
                    </div>
                </div>

                <div className="how-block">
                    <div className="inner-content">
                        <BodyText content={config.how} />
                    </div>
                </div>

                <div className="banner3">
                    <Banner content={config.banner3} />
                </div>

                <div className="study-block">
                    <div className="inner-content">
                        <BodyText content={config.study} />

                        <div className="video1-wrapper">
                            <BodyText content={config.study.youtube1} />

                            <YoutubeVideo id={config.study.youtube1.id} />
                        </div>

                        <div className="video2-wrapper">
                            <BodyText content={config.study.youtube2} />

                            <YoutubeVideo id={config.study.youtube2.id} />
                        </div>
                    </div>
                </div>

                <div className="quote-block">
                    <div className="inner-content">
                        <div className="quote-wrapper">
                            <span className="quote-icon"></span>

                            <p className="speech" dangerouslySetInnerHTML={{__html:config.quote.speech}}></p>

                            <span className="author" dangerouslySetInnerHTML={{__html:config.quote.author}}></span>
                        </div>
                    </div>
                </div>

                <div className="survey-block">
                    <div className="inner-content">
                        <BodyText content={config.survey} />
                    </div>
                </div>

                <div className="banner4">
                    <Banner content={config.banner4} />
                </div>

                <div className="faq-block">
                    <div className="inner-content">
                        <BodyText content={config.faq} />

                        <div className="sections">
                            {config.faq.sections.map((section, i) => {
                                return (
                                    <div className="section" key={i}>
                                        <h3 className="subheading" dangerouslySetInnerHTML={{__html:section.subheading}}></h3>

                                        <Accordion bars={section.bars} type="multiple">
                                            {section.answers.map((answer, j) => {
                                                return (
                                                    <div className="answer" key={j}>
                                                        <div className="paragraphs">
                                                            {answer.body.map((paragraph, k) => {
                                                                return (
                                                                    <p key={k} dangerouslySetInnerHTML={{__html:paragraph}}></p>
                                                                )
                                                            })}
                                                        </div>

                                                        {answer.list &&
                                                            <ul className="list">
                                                                {answer.list.map((bullet, k) => {
                                                                    return (
                                                                        <li className="bullet" key={k} dangerouslySetInnerHTML={{__html:bullet}}></li>
                                                                    )
                                                                })}
                                                            </ul>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </Layout>
        </div>
    )
}
